module.exports = __webpack_public_path__ + "img/answer_4.6597a8cd.png";